import { useEffect, useRef, useState } from 'react'
import CreateButton from '../../../../Partials/Layouts/CRUDs/CRUDHeader/CreateButton/CreateButton';
import CRUDTable from '../../../../Partials/Layouts/CRUDs/CRUDTable/CRUDTable';
import CRUDTableHeader from '../../../../Partials/Layouts/CRUDs/CRUDTable/CRUDTableHeader/CRUDTableHeader';
import CRUDth from '../../../../Partials/Layouts/CRUDs/CRUDTable/CRUDTableHeader/CRUDth/CRUDth';
import ViewButton from '../../../../Partials/Layouts/CRUDs/CRUDButtons/ViewButton/ViewButton';
import EditButton from '../../../../Partials/Layouts/CRUDs/CRUDButtons/EditButton/EditButton';
import DeleteButton from '../../../../Partials/Layouts/CRUDs/CRUDButtons/DeleteButton/DeleteButton';
import ShortTextCell from '../../../../Partials/Layouts/CRUDs/CRUDTable/CRUDTableCells/ShortTextCell/ShortTextCell';
import CRUDTableRow from '../../../../Partials/Layouts/CRUDs/CRUDTable/CRUDTableRow/CRUDTableRow';
import Modal from '../../../../Partials/Elements/Modal/Modal';
import CreateLoyaltyClubs from './CreateLoyaltyClubs';
import ViewLoyaltyClubs from './ViewLoyaltyClub';
import useAxiosInstance from '../../../../../Utilities/Hooks/useAxiosInstance';
import DeleteItem from '../../../../Partials/Layouts/DeleteItem/DeleteItem';
import UpdateLoyaltyClubs from './UpdateLoyaltyClub';
import { LOYALTY_CLUB_API } from '../../../../../Utilities/APIs/APIs';


function LoyaltyClubs() {

  const axiosInstance = useAxiosInstance()

  const [loyaltyClubs, setLoyaltyClubs] = useState(null)
  const screenHeaerRef = useRef()
  const [screenHeaderHeight, setScreenHeaderHeight] = useState(0);

  useEffect(() => {
    let screenHeaderHeight = screenHeaerRef.current.clientHeight;
    setScreenHeaderHeight(screenHeaderHeight)
  }, [screenHeaerRef]);

  const [showCreateForm, setShowCreateForm] = useState(false);
  const [showViewSection, setShowViewSection] = useState(false);
  const [showUpdateForm, setShowUpdateForm] = useState(false);
  const [showDeleteSection, setShowDeleteSection] = useState(false)
  const [toggleFetch, setToggleFetch] = useState(false)

  const [targetID, setTargetID] = useState(null)

  useEffect(() => {

  async function fetchAndsetsetLoyaltyClubs() {
      const { data } = await axiosInstance.get(LOYALTY_CLUB_API)
      setLoyaltyClubs(data)
    }
    fetchAndsetsetLoyaltyClubs()

  }, [toggleFetch, axiosInstance])

  function triggerFetch() {
    setToggleFetch(prevState => !prevState)
  }
  return (
    <>
      <div className='screen_header' ref={screenHeaerRef}>
        <h1 className='screen_heading'>LoyaltyClubs ({loyaltyClubs?.length}  in total)</h1>
        <CreateButton
          screenTopicSingular={'LoyaltyClubs'}
          setShowCreateForm={setShowCreateForm}
        /> 
      </div>
      <CRUDTable screenHeaderHeight={screenHeaderHeight}>
        <CRUDTableHeader>
          <CRUDth th='Club Name' />
          <CRUDth th='Points' />
          <CRUDth th='Color' />
          <CRUDth th='Actions' />
        </CRUDTableHeader>
        <tbody>
          {
            loyaltyClubs?.map(loyaltyClub =>
              <CRUDTableRow key={loyaltyClub._id}>
                <ShortTextCell text={loyaltyClub.clubName} />
                <ShortTextCell text={loyaltyClub.points} />
                <ShortTextCell text={loyaltyClub.bgColor} />
                <td>
                  <div className="action_buttons_wrapper">
                    <div className="action_buttons">
                      <ViewButton
                        setShowViewSection={setShowViewSection}
                        targetID={loyaltyClub._id}
                        setTargetID={setTargetID}
                        tooltipName={"View"} 
                        tooltipContent={"View"}
                      />

                      <EditButton
                        setShowUpdateForm={setShowUpdateForm}
                        targetID={loyaltyClub._id}
                        setTargetID={setTargetID}
                        tooltipName={"Edit"} 
                        tooltipContent={"Edit"}
                      />

                      <DeleteButton
                        setShowDeleteSection={setShowDeleteSection}
                        targetID={loyaltyClub._id}
                        setTargetID={setTargetID}
                      />
                    </div>
                  </div>
                </td>
              </CRUDTableRow>

            )
          }
        </tbody>
      </CRUDTable>
      {

        showCreateForm &&
        <Modal
          extraClass={'small'}
          modalHeading={`Add LoyaltyClub`}
          setShowModalContent={setShowCreateForm}
        >
          <CreateLoyaltyClubs
            triggerFetch={triggerFetch}
            setShowCreateForm={setShowCreateForm}
          />
        </Modal>
  
      }
      {
        showUpdateForm &&
        <Modal
          extraClass={'small'}
          modalHeading={`Update LoyaltyClub`}
          setShowModalContent={setShowUpdateForm}
        >
          <UpdateLoyaltyClubs
            triggerFetch={triggerFetch}
            targetID={targetID}
            setShowUpdateForm={setShowUpdateForm}
          />
        </Modal>
      }
      {
        showViewSection &&
        <Modal
          extraClass={'small'}
          modalHeading={`View LoyaltyClub`}
          setShowModalContent={setShowViewSection}
        >
          <ViewLoyaltyClubs
            targetID={targetID}
          />
        </Modal>
      }
      {
        showDeleteSection &&
        <Modal
          extraClass={'small'}
          modalHeading={`Delete loyaltyClub`}
          setShowModalContent={setShowDeleteSection}
        >
          <DeleteItem
            api={LOYALTY_CLUB_API}
            triggerFetch={triggerFetch}
            targetID={targetID}
            setShowDeleteItem={setShowDeleteSection}
          />
        </Modal>
      }
    </>
  )
}

export default LoyaltyClubs